import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO_URL, CONTACT } from "@/data/content";

export const LegalLayout = ({ title, children, testId }) => {
  return (
    <main data-testid={testId} className="bg-white min-h-screen">
      <header className="border-b border-zinc-200 backdrop-blur-xl bg-white/70 sticky top-0 z-50">
        <div className="max-w-[900px] mx-auto px-6 md:px-8 h-20 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo-link" className="flex items-center">
            <img src={LOGO_URL} alt="inn'spective" className="h-10 w-auto object-contain" />
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="group inline-flex items-center gap-2 text-sm font-medium text-zinc-600 hover:text-zinc-900 transition-colors"
          >
            <ArrowLeft className="w-4 h-4 group-hover:-translate-x-0.5 transition-transform" />
            Zur Startseite
          </Link>
        </div>
      </header>

      <div className="max-w-[900px] mx-auto px-6 md:px-8 py-16 md:py-24">
        <span className="font-mono text-xs tracking-[0.25em] uppercase text-zinc-400">
          Rechtliches
        </span>
        <h1 className="font-display font-semibold tracking-tight text-4xl md:text-6xl text-zinc-950 mt-4 leading-none">
          {title}
        </h1>
        <div className="mt-12 legal-body space-y-8 text-zinc-700 leading-relaxed">
          {children}
        </div>
      </div>

      <footer className="border-t border-zinc-200">
        <div className="max-w-[900px] mx-auto px-6 md:px-8 py-8 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-zinc-500">
          <span>© {new Date().getFullYear()} inn&apos;spective — {CONTACT.founder}</span>
          <div className="flex items-center gap-6">
            <Link to="/impressum" className="hover:text-zinc-900 transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-zinc-900 transition-colors">Datenschutz</Link>
          </div>
        </div>
      </footer>
    </main>
  );
};

export const LegalSection = ({ heading, children }) => (
  <section>
    <h2 className="font-display font-semibold text-xl md:text-2xl text-zinc-950 mb-3">
      {heading}
    </h2>
    <div className="space-y-3 text-[15px] md:text-base">{children}</div>
  </section>
);
